//Deployment

export const REG_API_URL = "https://doctors.innovis24.com/Doctor_search/Registrationform.php";
export const USER_API_URL = "https://doctors.innovis24.com/Doctor_search/Usermaster.php";
export const HOS_API_URL = "https://doctors.innovis24.com/Doctor_search/HospitalDetails.php";
export const API_URL = "https://doctors.innovis24.com/Doctor_search";

//Local

// export const REG_API_URL = "http://localhost/Doctor_search/Registrationform.php";
// export const USER_API_URL = "http://localhost/Doctor_search/Usermaster.php";
// export const HOS_API_URL = "http://localhost/Doctor_search/HospitalDetails.php";
// export const API_URL = "http://localhost/Doctor_search";